"use client"

import { motion } from "framer-motion"
import { FileText, AlertTriangle, DollarSign, HelpCircle } from "lucide-react"
import "../styles/QuemSomos.css"

const PoliticaCancelamento = () => {
  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 },
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="quem-somos-container"
    >
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="titulo"
      >
        <FileText className="titulo-icon" />
        Política de Cancelamento e Reembolso
      </motion.h1>

      <div className="conteudo">
        <motion.p {...fadeIn} transition={{ duration: 0.5, delay: 0.3 }}>
          Pensando sempre em garantir transparência e confiança, o <strong>Ticket do Vaqueiro</strong> estabelece, nesta
          página, todas as diretrizes relacionadas ao cancelamento de serviços/produtos adquiridos e reembolso dos
          valores investidos. Nosso objetivo é esclarecer de forma simples e objetiva as condições aplicáveis.
        </motion.p>

        <motion.div {...fadeIn} transition={{ duration: 0.5, delay: 0.4 }} className="section">
          <h2>
            <AlertTriangle size={22} className="section-icon" />
            Cancelamento de Compras
          </h2>
          <p>
            Os clientes que realizarem a compra de qualquer senha através do <strong>Ticket do Vaqueiro</strong> poderão
            solicitar o cancelamento da mesma, respeitando as seguintes condições:
          </p>
          <ul className="policy-list">
            <li>
              <span className="bullet">•</span>O pedido de cancelamento deverá ser feito{" "}
              <strong>antes do encerramento oficial das vendas antecipadas da vaquejada correspondente</strong>.
            </li>
            <li>
              <span className="bullet">•</span>
              Para solicitar, é necessário entrar em contato pelos canais de atendimento informados em nosso site.
            </li>
            <li>
              <span className="bullet">•</span>O valor integral da senha será devolvido.{" "}
              <strong>
                Taxas administrativas e juros cobrados por operadoras de cartão de crédito não serão reembolsados
              </strong>
              .
            </li>
          </ul>
        </motion.div>

        <motion.div {...fadeIn} transition={{ duration: 0.5, delay: 0.5 }} className="section">
          <h2>
            <DollarSign size={22} className="section-icon" />
            Reembolsos
          </h2>
          <p>Para reembolsos, seguem as condições específicas:</p>
          <ul className="policy-list">
            <li>
              <span className="bullet">•</span>O prazo máximo para solicitar o reembolso é até{" "}
              <strong>às 18h do último dia de venda online</strong> da senha. Após este horário, os valores já terão
              sido repassados à organização da vaquejada, impossibilitando o estorno.
            </li>
            <li>
              <span className="bullet">•</span>
              Uma vez solicitada a devolução dentro do prazo, o estorno será processado em até{" "}
              <strong>24 horas úteis</strong>.
            </li>
            <li>
              <span className="bullet">•</span>
              Após a confirmação do reembolso, a senha adquirida será automaticamente cancelada e invalidada para uso.
            </li>
            <li>
              <span className="bullet">•</span>
              Pagamentos realizados via <strong>boleto bancário</strong> serão reembolsados diretamente na conta
              bancária associada ao CPF do titular da compra. Os dados bancários devem ser informados no momento da
              solicitação.
            </li>
            <li>
              <span className="bullet">•</span>
              No caso de compras feitas com <strong>cartão de crédito</strong>, os valores serão estornados para a
              fatura do cliente. Ressaltamos que o crédito pode levar um ou dois ciclos de fatura para ser efetivado,
              conforme as regras da administradora do cartão.
            </li>
            <li>
              <span className="bullet">•</span>
              <strong>Taxas de administração e juros do cartão não serão restituídos.</strong>
            </li>
          </ul>
        </motion.div>

        <motion.div {...fadeIn} transition={{ duration: 0.5, delay: 0.6 }} className="contact-info">
          <HelpCircle size={20} className="contact-icon" />
          <p>Qualquer dúvida restante é só nos contatar pelo Fale Conosco.</p>
        </motion.div>
      </div>
    </motion.div>
  )
}

export default PoliticaCancelamento
